import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useDispatch } from "react-redux";
import { getUserProfile } from "../../redux/action/Profile";

export default function Model({
  icon,
  title,
  description,
  btnName = "Done",
  show,
  setShow,
}) {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
    setShow(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setShow(false);
  };
  const handleCancel = () => {
    dispatch(getUserProfile());
    setIsModalOpen(false);
    setShow(false);
  };
  useEffect(() => {
    setIsModalOpen(show);
  }, [show, isModalOpen]);

  return (
    <>
      <Modal
        title=""
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        modalRender={(modal) => (
          <div className="flex justify-center items-center w-full h-full">
            <div className="w-1/2">{modal}</div>
          </div>
        )}
      >
        <div className="relative px-2 py-2">
          <div className="flex flex-col justify-center items-center min-h-[260px]">
            <img src={icon} alt="img" className="w-[120px] h-[120px]" />
            <span className="text-[#4B61FF] text-[14px] font-bold text-center font-poppins">
              {title}
            </span>
            <span className="text-[#171717] text-[10px] font-poppins text-cente mt-2 text-center">
              {description}
            </span>
          </div>
          <div className="w-full h-[40px] absolute bottom-0 flex justify-center items-center bg-[#FFFFFF] ">
            <button
              className="h-[40px] w-[100px] btn-gradient rounded-xl text-[#FFFFFF] font-poppins text-[14px] mt-[30px]"
              onClick={handleCancel}
            >
              {btnName}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
